import {
  FetchMoreQueryOptions,
  NetworkStatus,
  OperationVariables,
  QueryResult,
} from '@apollo/client'

type InputData<TData, TVariables extends OperationVariables, TItem> = {
  items?: TItem[]
  totalItems?: number
  queryResult: QueryResult<TData, TVariables>
}

type ReturnData<TData, TVariables extends OperationVariables, TItem> = {
  loading: boolean
  items: TItem[]
  totalItems: number
  hasMoreItems: boolean
  fetchingMore: boolean
  refetch: () => void
  fetchMore: (options: FetchMoreQueryOptions<TVariables, TData>) => void
}

export function usePaginationData<
  TData,
  TVariables extends OperationVariables,
  TItem,
>(
  props: InputData<TData, TVariables, TItem>
): ReturnData<TData, TVariables, TItem> {
  const { loading, networkStatus, refetch, fetchMore } = props.queryResult

  const items = props.items ?? []
  const totalItems = props.totalItems ?? 0

  const hasMoreItems = items.length < totalItems

  return {
    loading,
    items,
    totalItems,
    hasMoreItems,
    fetchingMore: networkStatus === NetworkStatus.fetchMore,
    refetch,
    fetchMore,
  }
}
